import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'denkmalpflege-message',
    templateUrl: './denkmalpflege-message.component.html',
    styleUrls: ['./denkmalpflege-message.component.scss'],
    standalone: false
})
export class DenkmalpflegeMessageComponent implements OnInit {
  @Input() isDenkmalpflege: boolean;

  constructor() {}

  ngOnInit() {}
}
